var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgPin(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 30 42' }, props),
        React.createElement("path", { d: 'M14.643.25C6.813.25.25 6.345.25 15.358c0 6.511 4.621 15.099 13.823 25.84a.75.75 0 001.135.005C24.524 30.54 29.204 21.95 29.204 15.358 29.204 6.287 22.559.25 14.643.25zm0 1.5c7.118 0 13.06 5.399 13.06 13.608l-.003.298c-.139 5.904-4.379 13.78-12.756 23.559l-.296.343-.291-.345C5.94 29.196 1.75 21.22 1.75 15.358 1.75 7.2 7.617 1.75 14.643 1.75z' }),
        React.createElement("path", { d: 'M15 10.108a5.75 5.75 0 100 11.5 5.75 5.75 0 000-11.5zm0 1.5a4.25 4.25 0 110 8.5 4.25 4.25 0 010-8.5z' })));
}
export default SvgPin;
//# sourceMappingURL=Pin.js.map